import axios from 'axios';
import { getServerURL } from './urls';

export const sendContactFormEmail = params => {
  const {
    businessType,
    businessId,
    locationId,
    name,
    email,
    emailSubject,
    message,
    contactOptIn,
  } = params;
  const url = getServerURL();
  const fullUrl = `${url}businesses/${businessType}s/${businessId}/locations/${locationId}/email/`;

  return axios.post(fullUrl, {
    contact_name: name,
    contact_email: email,
    contact_message: message,
    contact_opt_in: contactOptIn,
    email_subject: emailSubject,
  });
};

export const searchDomains = potentialDomain => {
  const headers = {
    'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY,
  };
  const url = getServerURL();

  return axios.get(`${url}domains/search/details/?domain=${potentialDomain}`, {
    headers,
  });
};
